




















































import { defineComponent, ref, onMounted, onBeforeUnmount } from "@nuxtjs/composition-api";
import { PopularBoughtRecommendationsListOptions, loadProductRecommendationsActions } from "@coveo/headless/product-recommendation";
import { CarouselType, coveoFieldsToInclude } from '~/common';
import {
  coveoGetters,
  useCoveoHeadlessPopularBoughtProductRecommendation,
  useCoveoHeadlessPopularViewedProductRecommendation,
  useCoveoHeadlessFrequentlyBoughtTogetherRecommendation
} from "~/composables";
import {getCMSItem} from "~/helpers/globalLabels";

export default defineComponent({
  name: "ProductSlider",
  components: {
    SfCarousel: () => import('~/themes/fiskarsMoominDefault/components/components/organisms/SfCarousel/SfCarousel.vue'),
    SfProductCard: () => import('~/themes/fiskarsMoominDefault/components/components/organisms/SfProductCard/SfProductCard.vue'),
  },
  props: {
    badgeColor: {
      type: Object,
    },
    titleCarousel: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    link: {
      type: [Object, String],
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    productType: {
      type: Object as () => {
        sourceName: string;
        selectionValues: { key: CarouselType | string; label: string }[];
      },
      default: function () {
        return {
          sourceName: null,
          selectionValues: [
            {
              key: CarouselType.popularItemsBought,
              label: "Featured products"
            }
          ]
        };
      }
    },
    numberOfResults: {
      type: [Number, String],
      default: 10,
    },
    addToCart: {
      type: String,
      default: "Add To Cart",
    },
    autoplay: {
      type: Number,
      default: 0,
    },
    prodId: {
      type: [String, Number],
      default: "0"
    }
  },
  setup(props: any) {
    const loading = ref(true);
    let coveoEngine = null;
    let recommendationsList = null;



    const mapProductListData = (productList: any[]) => {
      let products = productList.map((product) => {
        return {
          id: product?.permanentid,
          image: product?.additionalFields?.imageurl ,
          name: product?.additionalFields?.shortname ? product?.additionalFields?.shortname : product?.ec_name,
          regularPrice: product?.additionalFields?.price_regular,
          specialPrice: product?.additionalFields?.price_discounted,
          lowestPrice: product?.additionalFields?.lowest_price,
          inStock: product?.additionalFields?.stock,
          excerpt: product?.excerpt,
          rating: product?.rating,
          genericType: product?.additionalFields?.classification_productgenerictype,
          specificType: product?.additionalFields?.classification_productspecifictype,
          handle: product?.additionalFields?.shortname,
          coveoData: product
        };
      });

      return products;
    }


    let productsList = ref([]);
    let unsubscribe;
    onMounted(() => {
      const options: PopularBoughtRecommendationsListOptions = {
        maxNumberOfRecommendations: Number(props.numberOfResults),
        additionalFields: coveoFieldsToInclude
      }
      const setFrequentlyBoughtTogether = () => {
        Object.assign(options, {sku: props.prodId})
        const { engine: frequentlyBoughtTogetherEngine, frequentlyBoughtTogetherList } = useCoveoHeadlessFrequentlyBoughtTogetherRecommendation(options);
        coveoEngine = frequentlyBoughtTogetherEngine;
        recommendationsList = frequentlyBoughtTogetherList;
      }

      const setPopularViewed = () => {
        const { engine: popularViewedEngine, popularViewedRecommendationsList } = useCoveoHeadlessPopularViewedProductRecommendation(options);
        coveoEngine = popularViewedEngine;
        recommendationsList = popularViewedRecommendationsList;
      }

      const setPopularBought = () => {
        const { engine: popularBoughtEngine, popularBoughtRecommendationsList } = useCoveoHeadlessPopularBoughtProductRecommendation(options);
        coveoEngine = popularBoughtEngine;
        recommendationsList = popularBoughtRecommendationsList;
      }

      switch(props?.productType?.selectionValues[0]?.key) {
      case CarouselType.frequentlyBoughtTogether:
        setFrequentlyBoughtTogether();
        break;
      case CarouselType.popularItemsViewed:
        setPopularViewed()
        break;
      case CarouselType.popularItemsBought:
      default:
        setPopularBought()
        break;
    }

    const productRecommendationActions = loadProductRecommendationsActions(coveoEngine);
    coveoEngine.dispatch(productRecommendationActions.getProductRecommendations());

      unsubscribe = recommendationsList?.subscribe(() => {
        productsList.value = mapProductListData(recommendationsList?.state?.recommendations);
        loading.value = false;
      });
    });

    onBeforeUnmount(() => {
      if (unsubscribe) {
        unsubscribe();
      }
    });


    const carouselSettings = ref({
      type: Object,
      settings: {
        type: "carousel",
        rewind: true,
        perView: 4,
        slidePerPage: true,
        autoplay: props.autoplay,
        gap: 0,
        breakpoints: {
          1023: {
            perView: 2,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      },
    });

    const getBadgeLabel = (regularPrice, specialPrice) => {
      if (regularPrice && specialPrice && regularPrice > specialPrice) {
        let percent = ((regularPrice - specialPrice) * 100) / regularPrice;
        return Math.floor(percent);
      } else {
        return;
      }
    };
    const getBadgeColor = () => {
      return getCMSItem('badge-color-discount-percentage') || "#FBAFA0";
    }

    return {
      loading,
      carouselSettings,
      getBadgeLabel,
      productsList,
      coveoGetters,
      getBadgeColor
    };
  },
});
